import { Fetcher } from "@/utils/fetcher";
import axios, { AxiosRequestConfig } from "axios";

const category = new Fetcher("category");
const product = new Fetcher("product");

category.setUseToken(false);

// get category by slug
export const getCategoryBySlug = (slug: string) =>
  category.get<CategoryItem>(`/storefront/${slug}`);

// get menu items // {{apiUrl}}/api/v1/category/storefront/get-menu
export const getMenuItems = () =>
  category.get<MenuItem[]>(`/storefront/get-menu`);

// get category by ids
export const getCategoriesByIds = (ids: number[]) =>
  category.post<CategoryItem[]>("/storefront/get-categories-by-ids", { ids });

// get category details by slug
export const getCategoryDetailsBySlug = (slug: string) =>
  category.get<CategoryItem>(`/storefront/get-one/${slug}`);

// get featured categories: {{apiUrl}}/api/v1/category/storefront/featured-categories?perPage=20&currentPage=1
export const getFeaturedCategories = ({
  perPage = 20,
  currentPage = 1,
  search,
  config,
}: Pagination & {
  config?: AxiosRequestConfig<any>;
}) =>
  category.get<CategoryListResponse>(
    `/storefront/featured-categories?perPage=${perPage}&currentPage=${currentPage}${
      search ? "&search=" + search : ""
    }`,
    config
  );

// category attributes: /category/filter/:category_slug
export const getCategoryAttributes = (slug: string) =>
  category.get<CategoryFilters>(`/filter/${slug}`);

// get category layer: /api/v1/category/storefront/get-all?parentId
export const getCategoryListLayer = ({
  parentId,
  perPage = 20,
  currentPage = 1,
  search,
  config,
}: {
  parentId?: number;
  config?: AxiosRequestConfig<any>;
} & Pagination) => {
  let url = `/storefront/filter/get-all`;
  if (parentId) {
    url += `?parentId=${parentId}`;
  }

  return category.get<CategoryItem[]>(url, config);
};

export const getCategoryListLayerCached = ({
  parentId,
  config,
}: {
  parentId?: number;
  config?: AxiosRequestConfig<any>;
}): Promise<CategoryItem[]> => {
  return new Promise(async (resolve, reject) => {
    try {
      let query = "";
      if (parentId) {
        query = `?parentId=${parentId}`;
      }
      const res = await axios.get<CategoryItem[]>(
        "/api/categoryLayer" + query,
        config
      );

      resolve(res.data);
    } catch (error) {
      reject(error);
    }
  });
};

// {{apiUrl}}/api/v1/product/storefront/online-exclusive-min-max
export const getOnlineExclusiveMinMax = () =>
  product.get<{
    highestPrice: number;
    lowestPrice: number;
  }>("/storefront/online-exclusive-min-max");
